module.exports = __webpack_public_path__ + "static/media/social-image.30c4a2ae.jpg";